import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-145ff7e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation-container" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Navigation", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Student Navigation", -1))
const _hoisted_5 = { class: "map-section" }
const _hoisted_6 = { class: "map-container" }
const _hoisted_7 = { class: "marker-popup" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"map-legend\" data-v-145ff7e1><div class=\"legend-item\" data-v-145ff7e1><img src=\"https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png\" alt=\"Student\" width=\"20\" data-v-145ff7e1><span data-v-145ff7e1>Student Location</span></div><div class=\"legend-item\" data-v-145ff7e1><img src=\"https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png\" alt=\"School\" width=\"20\" data-v-145ff7e1><span data-v-145ff7e1>School Location</span></div></div>", 1)
const _hoisted_9 = { class: "main-content" }
const _hoisted_10 = { class: "student-selection" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Select Students", -1))
const _hoisted_12 = { class: "filters" }
const _hoisted_13 = {
  key: 0,
  class: "filter-notice"
}
const _hoisted_14 = { class: "search-inputs" }
const _hoisted_15 = { class: "input-group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "studentSearch" }, "Search Students", -1))
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "schoolFilter" }, "Filter by School", -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "All Schools", -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "student-list" }
const _hoisted_23 = ["id", "value"]
const _hoisted_24 = ["for"]
const _hoisted_25 = { class: "school-name" }
const _hoisted_26 = { class: "trip-details" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Trip Details", -1))
const _hoisted_28 = { class: "trip-form" }
const _hoisted_29 = { class: "input-group" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tripName" }, "Trip Name", -1))
const _hoisted_31 = { class: "input-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tripDate" }, "Trip Date", -1))
const _hoisted_33 = { class: "time-inputs" }
const _hoisted_34 = { class: "input-group" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startTime" }, "Start Time", -1))
const _hoisted_36 = { class: "input-group" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endTime" }, "End Time", -1))
const _hoisted_38 = { class: "trip-notes" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tripNotes" }, "Notes", -1))
const _hoisted_40 = { class: "selected-count" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "delta1-section" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Delta1 Analysis", -1))
const _hoisted_44 = ["disabled"]
const _hoisted_45 = {
  key: 0,
  class: "delta1-table"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Student"),
    /*#__PURE__*/_createElementVNode("th", null, "School"),
    /*#__PURE__*/_createElementVNode("th", null, "Distance"),
    /*#__PURE__*/_createElementVNode("th", null, "Duration")
  ])
], -1))
const _hoisted_47 = { class: "delta2-section" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Delta2 Route Optimization", -1))
const _hoisted_49 = ["disabled"]
const _hoisted_50 = {
  key: 0,
  class: "delta2-table"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Segment"),
    /*#__PURE__*/_createElementVNode("th", null, "From"),
    /*#__PURE__*/_createElementVNode("th", null, "To"),
    /*#__PURE__*/_createElementVNode("th", null, "Distance"),
    /*#__PURE__*/_createElementVNode("th", null, "Duration"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Distance"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Duration")
  ])
], -1))

import { ref, computed, onMounted, watch } from "vue";
import { API_URL } from "../config";
import "leaflet/dist/leaflet.css";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LIcon,
  LPolyline,
} from "@vue-leaflet/vue-leaflet";
import type { LatLngTuple } from "leaflet";
import {
  getErrorMessage,
  type Delta1Result,
  type Delta2Result,
  type LeafletMapRef,
  type NavigationMarker,
  type NavigationSchool,
  type NavigationStudent,
  type OrganizationRecord,
  type RoutePoint,
  type StudentApiRecord,
  type TripDetails,
} from "../types";

// State

export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationView',
  setup(__props) {

const students = ref<NavigationStudent[]>([]);
const schools = ref<NavigationSchool[]>([]);
const selectedStudentIds = ref<number[]>([]);
const selectedSchoolId = ref<number | null>(null);
const filters = ref({
  student: "",
  schoolId: "",
});

const tripDetails = ref<TripDetails>({
  name: "",
  date: new Date().toISOString().split("T")[0],
  startTime: "",
  endTime: "",
  notes: "",
});

// Map state
const zoom = ref<number>(12);
const center = ref<LatLngTuple>([39.8283, -98.5795]);

// Sort schools alphabetically
const sortedSchools = computed(() => {
  return [...schools.value].sort((a, b) => a.name.localeCompare(b.name));
});

// Watch for changes in selected students to update selectedSchoolId
watch(selectedStudentIds, (newSelectedIds) => {
  if (newSelectedIds.length === 0) {
    selectedSchoolId.value = null;
    if (mapRef.value) {
      center.value = [39.8283, -98.5795];
      zoom.value = 12;
    }
    return;
  }

  // Get the first selected student's school
  const firstSelectedStudent = students.value.find(
    (s) => s.id === newSelectedIds[0]
  );
  if (firstSelectedStudent?.primarySchool) {
    selectedSchoolId.value = firstSelectedStudent.primarySchool.id;

    if (
      firstSelectedStudent.primarySchool.latitude &&
      firstSelectedStudent.primarySchool.longitude &&
      mapRef.value
    ) {
      center.value = [
        firstSelectedStudent.primarySchool.latitude,
        firstSelectedStudent.primarySchool.longitude,
      ];
      zoom.value = 13;
    }
  }
});

// Filter students based on search and school selection
const filteredStudents = computed(() => {
  return students.value.filter((student) => {
    const matchesSearch =
      student.firstName
        .toLowerCase()
        .includes(filters.value.student.toLowerCase()) ||
      student.lastName
        .toLowerCase()
        .includes(filters.value.student.toLowerCase());

    // Show all students if no school filter and no student selected
    if (!filters.value.schoolId && !selectedSchoolId.value) {
      return matchesSearch;
    }

    // If a student is selected, only show students from the same school
    if (selectedSchoolId.value) {
      return (
        matchesSearch && student.primarySchool?.id === selectedSchoolId.value
      );
    }

    // Otherwise, use the school filter
    return (
      matchesSearch &&
      student.primarySchool?.id === parseInt(filters.value.schoolId)
    );
  });
});

// Update markers when students or selection changes
const markers = computed<NavigationMarker[]>(() => {
  const studentMarkers: NavigationMarker[] = students.value
    .filter(
      (student) =>
        selectedStudentIds.value.includes(student.id) &&
        student.latitude !== undefined &&
        student.longitude !== undefined
    )
    .map((student) => ({
      id: student.id,
      latitude: student.latitude as number,
      longitude: student.longitude as number,
      type: "student" as const,
      label: `${student.firstName} ${student.lastName}`,
      name: student.primarySchool?.name || "No School",
      address: student.addressLine1 || "No Address",
    }));

  // Add school marker if students are selected
  if (selectedStudentIds.value.length > 0) {
    const firstStudent = students.value.find((s) =>
      selectedStudentIds.value.includes(s.id)
    );
    const school = firstStudent?.primarySchool;

    if (school?.latitude && school?.longitude) {
      studentMarkers.push({
        id: -1, // Use negative ID to avoid conflicts with student IDs
        latitude: school.latitude,
        longitude: school.longitude,
        type: "school" as const,
        label: "School",
        name: school.name,
        address: school.address || "",
      });
    }
  }

  return studentMarkers;
});

const mapRef = ref<LeafletMapRef | null>(null);

// Watch for changes in markers to update map bounds
watch(
  markers,
  (newMarkers) => {
    if (newMarkers.length > 0 && mapRef.value) {
      const bounds = newMarkers.map(
        (m) => [m.latitude, m.longitude] as LatLngTuple
      );
      mapRef.value.fitBounds(bounds, {
        padding: [50, 50],
        maxZoom: 15,
      });
    }
  },
  { deep: true }
);

const getMarkerIcon = (type: string) => {
  return type === "student"
    ? "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png"
    : "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png";
};

const showMarkerInfo = (marker: NavigationMarker) => {
  // Optional: Add any additional marker click handling
  console.log("Marker clicked:", marker);
};

const canCreateTrip = computed(() => {
  return (
    tripDetails.value.name &&
    tripDetails.value.date &&
    tripDetails.value.startTime &&
    tripDetails.value.endTime &&
    selectedStudentIds.value.length > 0
  );
});

const createTrip = async () => {
  try {
    // Check if all selected students are from the same school
    const selectedStudents = students.value.filter((s) =>
      selectedStudentIds.value.includes(s.id)
    );
    const schoolIds = new Set(selectedStudents.map((s) => s.primarySchool?.id));

    if (schoolIds.size > 1) {
      alert("All students in a trip must be from the same school");
      return;
    }

    const response = await fetch(`${API_URL}/trips`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        ...tripDetails.value,
        studentIds: selectedStudentIds.value,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Failed to create trip");
    }

    await response.json();
    // Reset form and selection
    tripDetails.value = {
      name: "",
      date: new Date().toISOString().split("T")[0],
      startTime: "",
      endTime: "",
      notes: "",
    };
    selectedStudentIds.value = [];

    alert("Trip created successfully! You can view it in the trips page.");
  } catch (error: unknown) {
    console.error("Error creating trip:", error);
    alert(
      `Failed to create trip: ${getErrorMessage(
        error,
        "Failed to create trip"
      )}`
    );
  }
};

// Methods
const fetchData = async () => {
  try {
    const [studentsResponse, schoolsResponse] = await Promise.all([
      fetch(`${API_URL}/students`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
      fetch(`${API_URL}/organizations`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    ]);

    if (!studentsResponse.ok || !schoolsResponse.ok) {
      const error = (await studentsResponse.ok)
        ? await schoolsResponse.json()
        : await studentsResponse.json();
      throw new Error(error.message || "Failed to fetch data");
    }

    const studentsData = (await studentsResponse.json()) as StudentApiRecord[];
    const schoolsData = (await schoolsResponse.json()) as OrganizationRecord[];

    students.value = studentsData.map((student) => ({
      ...student,
      latitude: student.lat,
      longitude: student.lng,
      school: student.primarySchool,
    }));

    schools.value = schoolsData.map((school) => ({
      id: school.id,
      name: school.name,
      address: school.address,
      latitude: Number(school.latitude) || 0,
      longitude: Number(school.longitude) || 0,
    }));

    // Update map center to first school if available
    if (schools.value.length > 0) {
      const firstSchool = schools.value[0];
      center.value = [firstSchool.latitude, firstSchool.longitude];
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    alert(
      "Failed to load students and schools. Please check your connection and try again."
    );
  }
};

onMounted(() => {
  fetchData();
});

const isGenerating = ref(false);
const delta1Data = ref<Delta1Result[]>([]);

const generateDelta1 = async () => {
  try {
    isGenerating.value = true;
    const response = await fetch(`${API_URL}/delta1/generate`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (response.ok) {
      delta1Data.value = await response.json();
    } else {
      alert("Failed to generate Delta1 data");
    }
  } catch (error) {
    console.error("Error generating Delta1:", error);
    alert("Error generating Delta1 data");
  } finally {
    isGenerating.value = false;
  }
};

const isGeneratingDelta2 = ref(false);
const delta2Data = ref<Delta2Result[]>([]);
const routeLines = ref<Array<[number, number][]>>([]);
const routeColor = ref("#2196f3");
const routeWeight = ref(3);
const routeOpacity = ref(0.8);

const generateDelta2 = async () => {
  try {
    isGeneratingDelta2.value = true;
    const response = await fetch(`${API_URL}/delta2/generate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        studentIds: selectedStudentIds.value,
      }),
    });

    if (response.ok) {
      delta2Data.value = await response.json();
      // Create route lines from the ordered points
      const points = await getRoutePoints();
      if (points.length >= 2) {
        routeLines.value = [points.map((p) => [p.latitude, p.longitude])];
      }
    } else {
      alert("Failed to generate Delta2 data");
    }
  } catch (error) {
    console.error("Error generating Delta2:", error);
    alert("Error generating Delta2 data");
  } finally {
    isGeneratingDelta2.value = false;
  }
};

const getRoutePoints = async (): Promise<RoutePoint[]> => {
  const selectedStudents = students.value.filter((s) =>
    selectedStudentIds.value.includes(s.id)
  );

  if (selectedStudents.length === 0) return [];

  const studentIdToCoords = new Map<number, RoutePoint>();
  selectedStudents.forEach((student) => {
    if (
      student.id &&
      student.latitude !== undefined &&
      student.longitude !== undefined
    ) {
      studentIdToCoords.set(student.id, {
        latitude: student.latitude,
        longitude: student.longitude,
      });
    }
  });

  const routePoints: RoutePoint[] = [];
  for (const segment of delta2Data.value) {
    let startCoords: RoutePoint | undefined;
    if (
      segment.startStudentId !== undefined &&
      segment.startStudentId !== null
    ) {
      startCoords = studentIdToCoords.get(segment.startStudentId);
    }
    if (
      !startCoords &&
      segment.startLat !== undefined &&
      segment.startLng !== undefined
    ) {
      startCoords = { latitude: segment.startLat, longitude: segment.startLng };
    }
    if (
      startCoords &&
      !routePoints.some(
        (p) =>
          p.latitude === startCoords.latitude &&
          p.longitude === startCoords.longitude
      )
    ) {
      routePoints.push(startCoords);
    }

    let endCoords: RoutePoint | undefined;
    if (segment.endStudentId !== undefined && segment.endStudentId !== null) {
      endCoords = studentIdToCoords.get(segment.endStudentId);
    }
    if (
      !endCoords &&
      segment.endLat !== undefined &&
      segment.endLng !== undefined
    ) {
      endCoords = { latitude: segment.endLat, longitude: segment.endLng };
    }
    if (
      endCoords &&
      !routePoints.some(
        (p) =>
          p.latitude === endCoords.latitude &&
          p.longitude === endCoords.longitude
      )
    ) {
      routePoints.push(endCoords);
    }
  }

  return routePoints;
};

// Add watch to clear route lines when selection changes
watch(selectedStudentIds, () => {
  routeLines.value = [];
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _hoisted_3
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(LMap), {
          ref: "map",
          zoom: zoom.value,
          "onUpdate:zoom": _cache[0] || (_cache[0] = ($event: any) => ((zoom).value = $event)),
          center: center.value,
          "use-global-leaflet": false
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(LTileLayer), {
              url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
              "layer-type": "base",
              name: "OpenStreetMap"
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markers.value, (marker) => {
              return (_openBlock(), _createBlock(_unref(LMarker), {
                key: marker.id,
                "lat-lng": [marker.latitude, marker.longitude],
                onClick: ($event: any) => (showMarkerInfo(marker))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(LIcon), {
                    "icon-url": getMarkerIcon(marker.type),
                    "icon-size": [25, 41]
                  }, null, 8, ["icon-url"]),
                  _createVNode(_unref(LPopup), null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", {
                          class: _normalizeClass(marker.type)
                        }, _toDisplayString(marker.label), 3),
                        _createElementVNode("h4", null, _toDisplayString(marker.name), 1),
                        _createElementVNode("p", null, _toDisplayString(marker.address), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["lat-lng", "onClick"]))
            }), 128)),
            (routeLines.value.length > 0)
              ? (_openBlock(), _createBlock(_unref(LPolyline), {
                  key: 0,
                  "lat-lngs": routeLines.value,
                  color: routeColor.value,
                  weight: routeWeight.value,
                  opacity: routeOpacity.value
                }, null, 8, ["lat-lngs", "color", "weight", "opacity"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["zoom", "center"])
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          (selectedSchoolId.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createTextVNode(" Showing only students from " + _toDisplayString(students.value.find((s) => s.primarySchool?.id === selectedSchoolId.value)
                ?.primarySchool?.name) + " ", 1),
                _createElementVNode("button", {
                  class: "clear-filter",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {
                selectedSchoolId.value = null;
                selectedStudentIds.value = [];
              })
                }, " Clear Selection ")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.student) = $event)),
                id: "studentSearch",
                placeholder: "Search by student name"
              }, null, 512), [
                [_vModelText, filters.value.student]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.schoolId) = $event)),
                id: "schoolFilter",
                disabled: selectedSchoolId.value !== null
              }, [
                _hoisted_20,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedSchools.value, (school) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: school.id,
                    value: school.id
                  }, _toDisplayString(school.name), 9, _hoisted_21))
                }), 128))
              ], 8, _hoisted_19), [
                [_vModelSelect, filters.value.schoolId]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredStudents.value, (student) => {
            return (_openBlock(), _createElementBlock("div", {
              key: student.id,
              class: _normalizeClass(["student-item", { selected: selectedStudentIds.value.includes(student.id) }])
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: 'student-' + student.id,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedStudentIds).value = $event)),
                value: student.id
              }, null, 8, _hoisted_23), [
                [_vModelCheckbox, selectedStudentIds.value]
              ]),
              _createElementVNode("label", {
                for: 'student-' + student.id
              }, [
                _createTextVNode(_toDisplayString(student.firstName) + " " + _toDisplayString(student.lastName) + " ", 1),
                _createElementVNode("span", _hoisted_25, _toDisplayString(student.school?.name), 1)
              ], 8, _hoisted_24)
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tripDetails.value.name) = $event)),
              id: "tripName",
              placeholder: "Enter trip name"
            }, null, 512), [
              [_vModelText, tripDetails.value.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tripDetails.value.date) = $event)),
              id: "tripDate",
              type: "date"
            }, null, 512), [
              [_vModelText, tripDetails.value.date]
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((tripDetails.value.startTime) = $event)),
                id: "startTime",
                type: "time"
              }, null, 512), [
                [_vModelText, tripDetails.value.startTime]
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((tripDetails.value.endTime) = $event)),
                id: "endTime",
                type: "time"
              }, null, 512), [
                [_vModelText, tripDetails.value.endTime]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((tripDetails.value.notes) = $event)),
              id: "tripNotes",
              placeholder: "Enter trip notes"
            }, null, 512), [
              [_vModelText, tripDetails.value.notes]
            ])
          ]),
          _createElementVNode("div", _hoisted_40, " Selected Students: " + _toDisplayString(selectedStudentIds.value.length), 1),
          _createElementVNode("button", {
            onClick: createTrip,
            disabled: !canCreateTrip.value,
            class: "create-trip-btn"
          }, " Create Trip ", 8, _hoisted_41)
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _hoisted_43,
        _createElementVNode("button", {
          onClick: generateDelta1,
          class: "generate-delta1-btn",
          disabled: isGenerating.value
        }, _toDisplayString(isGenerating.value ? "Generating..." : "Generate Delta1"), 9, _hoisted_44),
        (delta1Data.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("table", null, [
                _hoisted_46,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(delta1Data.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.studentName
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.studentName), 1),
                      _createElementVNode("td", null, _toDisplayString(item.schoolName), 1),
                      _createElementVNode("td", null, _toDisplayString(item.distance), 1),
                      _createElementVNode("td", null, _toDisplayString(item.duration), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_47, [
        _hoisted_48,
        _createElementVNode("button", {
          onClick: generateDelta2,
          class: "generate-delta2-btn",
          disabled: isGeneratingDelta2.value || selectedStudentIds.value.length === 0
        }, _toDisplayString(isGeneratingDelta2.value ? "Generating..." : "Generate Optimal Route"), 9, _hoisted_49),
        (delta2Data.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              _createElementVNode("table", null, [
                _hoisted_51,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(delta2Data.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.segmentNumber
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.segmentNumber), 1),
                      _createElementVNode("td", null, _toDisplayString(item.startAddress), 1),
                      _createElementVNode("td", null, _toDisplayString(item.endAddress), 1),
                      _createElementVNode("td", null, _toDisplayString(item.distance), 1),
                      _createElementVNode("td", null, _toDisplayString(item.duration), 1),
                      _createElementVNode("td", null, _toDisplayString(item.cumulativeDistance), 1),
                      _createElementVNode("td", null, _toDisplayString(item.cumulativeDuration), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})